module.exports = __webpack_public_path__ + "b8a97f7c4ba4240e4ab60501715aae9f.svg";